var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3E4F2102-2D2F-42C9-A37E-195081E36BC4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Doctor-App+Dash",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-57",
    transform: "translate(-749.000000, -934.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(395.000000, 871.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy",
    transform: "translate(333.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3",
    transform: "translate(15.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Channels/icons-black/question",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,4 C19.5228475,4 24,8.4771525 24,14 C24,19.5228475 19.5228475,24 14,24 L7,24 C5.34314575,24 4,22.6568542 4,21 L4,14 C4,8.4771525 8.4771525,4 14,4 Z M14,6 C9.581722,6 6,9.581722 6,14 L6,21 C6,21.5522847 6.44771525,22 7,22 L14,22 C18.418278,22 22,18.418278 22,14 C22,9.581722 18.418278,6 14,6 Z M14.2522274,16 C14.6652108,16 15,16.4438648 15,17 C15,17.5522847 14.6602228,18 14.2522274,18 L9.7477726,18 C9.3347892,18 9,17.5561352 9,17 C9,16.4477153 9.33977723,16 9.7477726,16 L14.2522274,16 Z M18.1646056,12 C18.6259812,12 19,12.4438648 19,13 C19,13.5522847 18.6201992,14 18.1646056,14 L9.83539441,14 C9.37401882,14 9,13.5561352 9,13 C9,12.4477153 9.3798008,12 9.83539441,12 L18.1646056,12 Z",
    id: "Combined-Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextMessage);
export default __webpack_public_path__ + "static/media/text-message.5def6e60e054660757f6929bc6f2b2b5.svg";
export { ForwardRef as ReactComponent };